import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    BULK_UPDATE_ADVERT,
    CREATE_ADVERT,
    DELETE_ADVERT,
    GET_ADVERT_DETAILS,
    GET_ADVERT_INQUIRY_LISTING,
    GET_ADVERT_LISTING,
    GET_COE_BIDDING_LIST,
    GET_ADVERT_REMARK_LISTING,
    GET_ERP_DETAILS,
    GET_ERP_LISTING,
    REQUEST_MAKE_MODEL,
    REQUEST_SINGPASS,
    UPDATE_ADVERT,
} from "./actionTypes.js";

import {
    createAdvertSuccess,
    createAdvertFail,
    getAdvertListingSuccess,
    getAdvertListingFail,
    getCoeBiddingListSuccess,
    getCoeBiddingListFail,
    getAdvertDetailsSuccess,
    getAdvertDetailsFail,
    updateAdvertSuccess,
    updateAdvertFail,
    deleteAdvertSuccess,
    deleteAdvertFail,
    getErpListingSuccess,
    getErpListingFail,
    getAdvertRemarkListingSuccess,
    getAdvertRemarkListingFail,
    getAdvertInquiryListingSuccess,
    getAdvertInquiryListingFail,
    bulkUpdateAdvertSuccess,
    bulkUpdateAdvertFail,
    requestMakeModelSuccess,
    requestMakeModelFail,
    getErpDetailsSuccess,
    getErpDetailsFail,
    requestSingpassSuccess,
    requestSingpassFail,
} from "./actions.js";

import { advertBulkUpdateApi, advertCreateApi, advertDeleteApi, advertDetailsApi, advertErpDetailsApi, advertErpListingApi, advertInquiryListingApi, advertListingApi, advertRemarkListingApi, advertRequestMakeModelApi, advertUpdateApi, coeBiddingApi, requestSingpassApi } from "./advertApi.js";

function* fetchAdvertListing({ payload }) {
    try {
        const response = yield call(advertListingApi, payload);
        yield put(getAdvertListingSuccess(response));
    } catch (error) {
        yield put(getAdvertListingFail(error));
    }
}

function* fetchCoeBiddingList({ payload }) {
    try {
        const response = yield call(coeBiddingApi, payload); 
        yield put(getCoeBiddingListSuccess(response));
    } catch (error) {
        yield put(getCoeBiddingListFail(error));
    }
}

function* fetchAdvertRemarkListing({ payload }) {
    try {
        const response = yield call(advertRemarkListingApi, payload);
        yield put(getAdvertRemarkListingSuccess(response));
    } catch (error) {
        yield put(getAdvertRemarkListingFail(error));
    }
}

function* fetchAdvertInquiryListing({ payload }) {
    try {
        const response = yield call(advertInquiryListingApi, payload);
        yield put(getAdvertInquiryListingSuccess(response));
    } catch (error) {
        yield put(getAdvertInquiryListingFail(error));
    }
}

function* fetchAdvertDetails({ payload }) {
    try {
        const response = yield call(advertDetailsApi, payload);
        yield put(getAdvertDetailsSuccess(response));
    } catch (error) {
        yield put(getAdvertDetailsFail(error));
    }
}

function* fetchAdvertErpListing({ payload }) {
    try {
        const response = yield call(advertErpListingApi, payload);
        yield put(getErpListingSuccess(response));
    } catch (error) {
        yield put(getErpListingFail(error));
    }
}

function* fetchAdvertErpDetails({ payload }) {
    try {
        const response = yield call(advertErpDetailsApi, payload);
        yield put(getErpDetailsSuccess(response));
    } catch (error) {
        yield put(getErpDetailsFail(error));
    }
}

function* fetchAdvertCreate({ payload }) {
    try {
        const response = yield call(advertCreateApi, payload);
        yield put(createAdvertSuccess(response));
    } catch (error) {
        yield put(createAdvertFail(error));
    }
}

function* fetchAdvertUpdate({ payload }) {
    try {
        const response = yield call(advertUpdateApi, payload);
        yield put(updateAdvertSuccess(response));
    } catch (error) {
        yield put(updateAdvertFail(error));
    }
}

function* fetchAdvertBulkUpdate({ payload }) {
    try {
        const response = yield call(advertBulkUpdateApi, payload);
        yield put(bulkUpdateAdvertSuccess(response));
    } catch (error) {
        yield put(bulkUpdateAdvertFail(error));
    }
}

function* fetchAdvertRequestMakeModel({ payload }) {
    try {
        const response = yield call(advertRequestMakeModelApi, payload);
        yield put(requestMakeModelSuccess(response));
    } catch (error) {
        yield put(requestMakeModelFail(error));
    }
}

function* fetchAdvertDelete({ payload }) {
    try {
        const response = yield call(advertDeleteApi, payload);
        yield put(deleteAdvertSuccess(response));
    } catch (error) {
        yield put(deleteAdvertFail(error));
    }
}

function* fetchAdvertSingpass({ payload }) {
    try {
        const response = yield call(requestSingpassApi, payload);
        yield put(requestSingpassSuccess(response));
    } catch (error) {
        yield put(requestSingpassFail(error));
    }
}

function* AdvertSaga() {
    yield takeEvery(GET_ADVERT_LISTING, fetchAdvertListing);
    yield takeEvery(GET_COE_BIDDING_LIST, fetchCoeBiddingList);
    yield takeEvery(GET_ADVERT_DETAILS, fetchAdvertDetails);
    yield takeEvery(GET_ADVERT_REMARK_LISTING, fetchAdvertRemarkListing);
    yield takeEvery(GET_ADVERT_INQUIRY_LISTING, fetchAdvertInquiryListing);
    yield takeEvery(GET_ERP_LISTING, fetchAdvertErpListing);
    yield takeEvery(GET_ERP_DETAILS, fetchAdvertErpDetails);
    yield takeEvery(CREATE_ADVERT, fetchAdvertCreate);
    yield takeEvery(UPDATE_ADVERT, fetchAdvertUpdate);
    yield takeEvery(BULK_UPDATE_ADVERT, fetchAdvertBulkUpdate);
    yield takeEvery(REQUEST_MAKE_MODEL, fetchAdvertRequestMakeModel);
    yield takeEvery(DELETE_ADVERT, fetchAdvertDelete);
    yield takeEvery(REQUEST_SINGPASS, fetchAdvertSingpass);
}

export default AdvertSaga